"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DocumentWithContent = /** @class */ (function () {
    function DocumentWithContent() {
    }
    return DocumentWithContent;
}());
exports.default = DocumentWithContent;
//# sourceMappingURL=DocumentWithContent.js.map